import React, {FC, useState} from "react";
import PropTypes             from 'prop-types';
import translator            from "counterpart";
import Translator            from "./Translator";
import i18next               from "i18next";

import nationalities from "../languages/nationalities.json";

const createNationalityOptions = () => {
    let sortedNationalities = [];
    for (let i = 0; i < Object.keys(nationalities).length; i++) {
        let key   = Object.keys(nationalities)[i];
        let value = nationalities[key];
        sortedNationalities.push({
                                     label: value['nationality'][translator.getLocale()],
                                     value: key
                                 });
    }

    sortedNationalities.sort(function(a, b) {
        const left  = cleanString(a.label);
        const right = cleanString(b.label);

        return ((left < right) ? -1 : ((a.label > right) ? 1 : 0));
    });

    return sortedNationalities;
}

export const cleanString = ($string) => {
    let clone = String($string);

    /* @formatter:off */
    const umlautMap = {
        '\u00dc': 'UE', //Ü
        '\u00c4': 'AE', //Ä
        '\u00C5': 'AE', //Å
        '\u00d6': 'OE', //Ö
        '\u00fc': 'ue', //ü
        '\u00e4': 'ae', //ä
        '\u00E5': 'ae', //å
        '\u00f6': 'oe', //ö
        '\u00df': 'ss', //ß
    }
    /* @formatter:on */

    Object.keys(umlautMap).forEach((searchValue) => {
        const newValue = umlautMap[searchValue];
        clone          = clone.replace(searchValue, newValue);
    })

    return clone;
}

const NationalitySelect = (props) => {
    const [options, setOptions] = useState(createNationalityOptions())
    const callback              = (lng) => {
        setOptions(createNationalityOptions());
    };
    i18next.on('languageChanged', callback);

    let className = "";
    let reqSpan   = '';
    let helpBlock = '';

    return (<div className={className}>
        <label
            htmlFor={props.name}
            className="control-label">
            <Translator content={props.label} />
            {reqSpan}
        </label>
        <select
            required={props.required}
            disabled={props.readOnly}
            className={"form-control _select-native " + props.className}
            id={props.name}
            name={props.name}
            value={props.value}
            onChange={props.onChange}
        >
            <option value={''}>  </option>
            <option value={'DE'}>{nationalities['DE']['nationality'][translator.getLocale()]}</option>
            <optgroup label="MORE">
                {options.map((option, index) => <option key={index} value={option.value}>{option.label}</option>)}
            </optgroup>
        </select>
        {helpBlock}
    </div>);
}

// Definition of LabeledInput component properties
NationalitySelect.propTypes = {
    className:    PropTypes.string, // Optional css class name string
    errormessage: PropTypes.string, // Optional error message string
    // formValidation: PropTypes.func, // Optional form validation function
    label:          PropTypes.string.isRequired, // Required input label
    name:           PropTypes.string.isRequired, // Required name (as identifier)
    onChange:       PropTypes.func, // Optional on value change function (to update global state)
    readOnly:       PropTypes.bool, // Optional read only modifier
    spawnWithError: PropTypes.bool, // Optional error display on first render (spawn)
    type:           PropTypes.string, // Optional type of the input
    value:          PropTypes.string // Optional default input value
};

// Definition of default LabeledInput component properties
NationalitySelect.defaultProps = {
    className:    "",
    errormessage: "There seems to be an error in this input.", // formValidation: (errors, fieldName) => {
    // },
    onChange:  (event) => {
    },
    readOnly:  false,
    minlength: 0, // spawnWithError: false,
    type:      "",
    label:     "",
    value:     ""
};

export default NationalitySelect;
